import api from './services/mkm.api'

const resource = 'musikschulerhalter';

export default{
    alle() {
        return api.get(`${resource}`)
    }
}